import moment from 'moment'
import md5 from 'md5'

export default function createFilePath (fileName) {
  const fileInfo = fileName.split(/\.(?![^\.]*\.)/)
  let random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  return `${moment().format('YYYY/MM/DD')}/${md5(fileInfo[0] + random(0, 100))}.${fileInfo[1]}`
}